/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_IdeasInputs */

const en_directory_ai_tools_eyebrow_ideas = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_IdeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideas`)
};

const zh_directory_ai_tools_eyebrow_ideas = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_IdeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`灵感`)
};

/**
* | output |
* | --- |
* | "Ideas" |
*
* @param {Directory_Ai_Tools_Eyebrow_IdeasInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_ideas = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_IdeasInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_IdeasInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_ideas(inputs)
	return zh_directory_ai_tools_eyebrow_ideas(inputs)
});
export { directory_ai_tools_eyebrow_ideas as "directory.ai_tools.eyebrow.ideas" }